import { ReadOnly, Select, useEntityPermission } from '@ui-framework/index';
import { observer } from 'mobx-react';
import React, { forwardRef } from 'react';
import { useFormContext } from 'react-hook-form';

const SelectStatic = forwardRef(
  ({ overwriteProps = {}, customConfig, ...props }, ref) => {
    const { options } = customConfig;
    const { getValues } = useFormContext();
    const { isHidden, isReadOnly } = useEntityPermission();

    const currentvalue = getValues(props?.field?.name);

    if (isReadOnly(props?.permission, currentvalue)) {
      return (
        <ReadOnly name={props?.field?.name}>
          {options.find(i => i.value === currentvalue)?.label}
        </ReadOnly>
      );
    }

    if (isHidden(props?.permission)) {
      return (
        <input type="hidden" name={props?.field?.name} value={currentvalue} />
      );
    }

    return (
      <Select
        ref={ref}
        options={options}
        {...props}
        overwriteProps={overwriteProps}
      />
    );
  },
);

export default observer(SelectStatic);
